export default "__VITE_ASSET__De2rj$jR__"